module.exports = require('../dist/selectors/education-loans');
